import { LogoMark } from '@cbhq/cds-web/icons/LogoMark';
import { HStack } from '@cbhq/cds-web/layout';
import { Divider } from '@cbhq/cds-web/layout/Divider';

export function Header() {
  return (
    <>
      <HStack spacing={3}>
        <LogoMark size={32} />
      </HStack>

      <Divider />
    </>
  );
}
